(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5091],{

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),

/***/ 65615:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles",
      function () {
        return __webpack_require__(611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ArticleListSection_ArticleListSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/CMS/ArticlePublisher/index.tsx
var ArticlePublisher = __webpack_require__(62173);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticleItemTop/ArticleItemTop.module.scss
var ArticleItemTop_module = __webpack_require__(2812);
var ArticleItemTop_module_default = /*#__PURE__*/__webpack_require__.n(ArticleItemTop_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleItemTop/ArticleItemTop.tsx









var ArticleItemTop = function(param) {
    var article = param.article;
    var ref;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("article", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (ArticleItemTop_module_default()).box,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (ArticleItemTop_module_default()).link,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ArticleItemTop_module_default()).cover,
                            children: [
                                article.cover ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                                    altText: article.cover.alternativeText || Image/* defaultAlt */.Zp,
                                    imageProps: article.cover,
                                    format: "small",
                                    layout: "fill"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: (ArticleItemTop_module_default()).cover__error,
                                    children: "Failed to load image..."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ArticleItemTop_module_default()).topLeft,
                                    children: (ref = article.article_category) === null || ref === void 0 ? void 0 : ref.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ArticleItemTop_module_default()).titleH2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h6",
                                component: "h2",
                                children: article.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ArticleItemTop_module_default()).blurb,
                            children: article.blurb
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePublisher/* ArticlePublisher */.n, {
                            author: article.author,
                            publishedDate: article.published_date
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var ArticleItemTop_ArticleItemTop = (ArticleItemTop);

;// CONCATENATED MODULE: ./components/CMS/ArticleItemTop/index.tsx


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/CMS/ArticleListSection/ArticleListSection.module.scss
var ArticleListSection_module = __webpack_require__(59565);
var ArticleListSection_module_default = /*#__PURE__*/__webpack_require__.n(ArticleListSection_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleListSection/ArticleListSection.tsx






var ArticleListSection = function(param) {
    var articles = param.articles, articleListTitle = param.articleListTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ArticleListSection_module_default()).container,
        children: [
            articleListTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleListSection_module_default()).titleContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h2",
                    children: articleListTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 3,
                children: articles.map(function(article) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        sm: 4,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItemTop_ArticleItemTop, {
                            article: article
                        })
                    }, article.id);
                })
            })
        ]
    });
};
/* harmony default export */ var ArticleListSection_ArticleListSection = (ArticleListSection);

;// CONCATENATED MODULE: ./components/CMS/ArticleListSection/index.tsx



/***/ }),

/***/ 611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ articles; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/CMS/ArticleListSection/index.tsx + 3 modules
var ArticleListSection = __webpack_require__(96386);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
var _array_with_holes = __webpack_require__(39474);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
var _non_iterable_rest = __webpack_require__(53128);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs





function _toArray(arr) {
  return (0,_array_with_holes/* default */.Z)(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || (0,_non_iterable_rest/* default */.Z)();
}

// EXTERNAL MODULE: ./components/CMS/ArticlePublisher/index.tsx
var ArticlePublisher = __webpack_require__(62173);
// EXTERNAL MODULE: ./components/CMS/CmsImage/index.ts + 2 modules
var CmsImage = __webpack_require__(78868);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Image/index.tsx + 2 modules
var Image = __webpack_require__(87113);
// EXTERNAL MODULE: ./components/CMS/ArticleItemCover/ArticleItemCover.module.scss
var ArticleItemCover_module = __webpack_require__(19322);
var ArticleItemCover_module_default = /*#__PURE__*/__webpack_require__.n(ArticleItemCover_module);
;// CONCATENATED MODULE: ./components/CMS/ArticleItemCover/ArticleItemCover.tsx









var ImageShape;
(function(ImageShape) {
    ImageShape["Small"] = "small";
    ImageShape["Large"] = "large";
})(ImageShape || (ImageShape = {}));
var ArticleItemCover = function(param) {
    var article = param.article, _imgShape = param.imgShape, imgShape = _imgShape === void 0 ? ImageShape.Large : _imgShape;
    var ref, ref1;
    var _alternativeText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ArticleItemCover_module_default()).container, (ArticleItemCover_module_default())[imgShape]),
        children: [
            article.cover && /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsImage/* default */.Z, {
                priority: true,
                imageProps: article.cover,
                altText: (_alternativeText = article.cover.alternativeText) !== null && _alternativeText !== void 0 ? _alternativeText : Image/* defaultAlt */.Zp,
                format: "medium",
                layout: "fill",
                objectFit: "cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArticleItemCover_module_default()).bgColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    prefetch: false,
                    href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article.slug),
                    as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (ArticleItemCover_module_default()).link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ArticleItemCover_module_default()).cover,
                            children: [
                                ((ref = article.article_category) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ArticleItemCover_module_default()).category,
                                    children: (ref1 = article.article_category) === null || ref1 === void 0 ? void 0 : ref1.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ArticleItemCover_module_default()).title,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: article.title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticlePublisher/* ArticlePublisher */.n, {
                                    author: article === null || article === void 0 ? void 0 : article.author,
                                    publishedDate: article === null || article === void 0 ? void 0 : article.published_date,
                                    fontColor: "white"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ArticleItemCover_ArticleItemCover = (ArticleItemCover);

;// CONCATENATED MODULE: ./components/CMS/ArticleItemCover/index.tsx


// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/CMS/FeaturedArticleSection/style.module.scss
var style_module = __webpack_require__(5207);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/CMS/FeaturedArticleSection/index.tsx








var FeaturedArticleSection = function(param) {
    var articles = param.articles;
    var _articles = _toArray(articles), first = _articles[0], rest = _articles.slice(1);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
        container: true,
        spacing: 3,
        className: (style_module_default()).container,
        children: [
            first && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                md: 7,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleItemCover_ArticleItemCover, {
                    article: first
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                item: true,
                md: 5,
                xs: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (style_module_default()).componentsTitle,
                        children: "Recent stories"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (style_module_default()).list,
                        children: rest.map(function(i, index) {
                            var ref, ref1;
                            return index <= 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    ((ref = i.article_category) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (style_module_default()).category,
                                        children: (ref1 = i.article_category) === null || ref1 === void 0 ? void 0 : ref1.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        prefetch: false,
                                        href: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(i.slug),
                                        as: "".concat(path/* PATH.ARTICLES */.m.ARTICLES, "/").concat(i.slug),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            title: i.title,
                                            children: i.title
                                        })
                                    })
                                ]
                            }, i.id);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/ContentHubContainer/index.tsx + 1 modules
var ContentHubContainer = __webpack_require__(26877);
;// CONCATENATED MODULE: ./pages/articles/index.tsx






var Articles = function(param) {
    var latestArticles = param.latestArticles, articlesWithCategories = param.articlesWithCategories, categoriesOnMenu = param.categoriesOnMenu, metaTitle = param.metaTitle, metaDescription = param.metaDescription, index = param.index;
    var ifShowFirstPart = function(l, i) {
        return i === 0 || i === 1 && l > 2;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHubContainer/* ContentHubContainer */._, {
        categories: categoriesOnMenu,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: metaTitle,
                description: metaDescription,
                noindex: !index,
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    type: "article"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedArticleSection, {
                articles: latestArticles
            }),
            articlesWithCategories.map(function(item, index) {
                return ifShowFirstPart(articlesWithCategories.length, index) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListSection/* default */.Z, {
                    articleListTitle: item.name,
                    articles: item.data
                }, item.name);
            }),
            articlesWithCategories.map(function(item, index) {
                return !ifShowFirstPart(articlesWithCategories.length, index) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListSection/* default */.Z, {
                    articleListTitle: item.name,
                    articles: item.data
                }, item.name);
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var articles = (Articles);


/***/ }),

/***/ 19322:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleItemCover_container___uQ_G","image":"ArticleItemCover_image__nPI_c","large":"ArticleItemCover_large__dE7rl","small":"ArticleItemCover_small__kBk_H","bgColor":"ArticleItemCover_bgColor__GFP92","cover":"ArticleItemCover_cover__ZCkbL","category":"ArticleItemCover_category__pDRvJ","link":"ArticleItemCover_link__1Ba45","title":"ArticleItemCover_title__NfCHI"};

/***/ }),

/***/ 2812:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"ArticleItemTop_box__UJ9kO","cover":"ArticleItemTop_cover__5cF5X","cover__error":"ArticleItemTop_cover__error__NqQWy","image":"ArticleItemTop_image__PbWnq","topLeft":"ArticleItemTop_topLeft__GvmXa","link":"ArticleItemTop_link__icClj","blurb":"ArticleItemTop_blurb__BtpI7","titleH2":"ArticleItemTop_titleH2__bf1Zu"};

/***/ }),

/***/ 59565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"ArticleListSection_titleContainer__HJ6MC","articles":"ArticleListSection_articles__hKDc4"};

/***/ }),

/***/ 5207:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"componentsTitle":"style_componentsTitle___n_w0","list":"style_list__iDySv","category":"style_category__rM_QQ"};

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  /* unused reexport */ __webpack_require__(69921);
} else {}


/***/ }),

/***/ 39474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}


/***/ }),

/***/ 53128:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,8612,554,9774,2888,179], function() { return __webpack_exec__(65615); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);